module.exports = __webpack_public_path__ + "static/media/parachuting-gold-yeti.80806b59.png";